var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRichiestaModificaMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 20.43 20.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-7188629",
    transform: "translate(-12.529 -12.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9625",
    "data-name": "Tracciato 9625",
    d: "M32.832,14.763,24.354,23.24a.955.955,0,0,1-.159.1l-3,1.124a.249.249,0,0,1-.046.012.1.1,0,0,1-.091-.147l1.124-3a.784.784,0,0,1,.1-.159L30.767,12.7a.388.388,0,0,1,.3-.125.306.306,0,0,1,.227.08l1.588,1.588a.389.389,0,0,1-.046.522Zm-8.239,9.646-3,1.124-.239.08h-.2A1.241,1.241,0,0,1,20,23.921l1.124-2.985a1.582,1.582,0,0,1,.363-.568l5.538-5.538H13.663a1.138,1.138,0,0,0-1.135,1.135V31.854a1.138,1.138,0,0,0,1.135,1.135H29.552a1.138,1.138,0,0,0,1.135-1.135V18.508L25.16,24.035a1.713,1.713,0,0,1-.568.375Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichiestaModificaMenu);
export default __webpack_public_path__ + "static/media/RichiestaModificaMenu.62fde1d5cea9873a0455fa87f8435c3e.svg";
export { ForwardRef as ReactComponent };